module.exports = __webpack_public_path__ + "assets/img/team-icon3.bfa15a9d.png";